import React from 'react';
import styles from "./DomainTaskTitleComponent.module.css"


  export const DomainTaskTitle: React.FunctionComponent = () => {
    return (
    <>
      <div className={styles.domainTaskHeaderBlock}>
        <p className={styles.domainTaskHeader}>What is this Task & Why is it Important?</p>
      </div>
    </>  
    );
  };